import { render, staticRenderFns } from "./bussinessPremiseSelect.vue?vue&type=template&id=bdf5e2aa&"
import script from "./bussinessPremiseSelect.vue?vue&type=script&lang=js&"
export * from "./bussinessPremiseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports